export const TENURE_REASONS = [
  ['ACQUISTO', 'Acquisto / compravendita'], ['VENDITA', 'Vendita / trasferimento'],
  ['DECESSO', 'Decesso'], ['SUCCESSIONE', 'Successione / eredità'],
  ['DONAZIONE', 'Donazione'], ['USUFRUTTO', 'Costituzione usufrutto'],
  ['FINE_USUFRUTTO', 'Estinzione usufrutto / riunione diritti'],
  ['LOCAZIONE', 'Inizio locazione'], ['FINE_LOCAZIONE', 'Fine locazione'],
  ['SENTENZA', 'Provvedimento / sentenza'], ['RETTIFICA', 'Rettifica documentata'], ['ALTRO', 'Altro'],
];
export const TODAY = () => new Date().toISOString().slice(0, 10);
export const datePart = (value) => value ? String(value).slice(0, 10) : '';
export const displayDate = (value) => datePart(value).split('-').reverse().join('/');
export const STATUS_LABELS = { CURRENT: 'Ancora titolare', ENDED: 'Non più titolare', FUTURE: 'Titolarità futura' };

export function tenureStatus(rel, today = TODAY()) {
  if (rel.relationship_type === 'EX_OWNER' || (rel.valid_to && datePart(rel.valid_to) < today)) return 'ENDED';
  if (rel.valid_from && datePart(rel.valid_from) > today) return 'FUTURE';
  return 'CURRENT';
}

export function tenureForm(rel = {}) {
  return { valid_from: datePart(rel.valid_from), valid_to: datePart(rel.valid_to),
    tenure_mode: rel.valid_to || rel.relationship_type === 'EX_OWNER' ? 'CLOSED' : 'OPEN',
    acquisition_reason: rel.acquisition_reason || '', cessation_reason: rel.cessation_reason || '' };
}

function validDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
}

export function tenurePayload(form) {
  const start = form.valid_from || '';
  const end = form.tenure_mode === 'CLOSED' ? (form.valid_to || '') : '';
  if (form.tenure_mode === 'CLOSED' && !end && form.relationship_type !== 'EX_OWNER') throw new Error('Indica la data di fine della titolarità.');
  if ((start && !validDate(start)) || (end && !validDate(end))) throw new Error('Controlla le date della titolarità.');
  if (start && end && end < start) throw new Error('La data di fine non può precedere la data di inizio.');
  if (form.relationship_type === 'EX_OWNER' && form.tenure_mode === 'OPEN') throw new Error('Per una titolarità attuale scegli il ruolo corrispondente, diverso da Ex proprietario.');
  return { valid_from: start ? `${start}T00:00:00` : null, valid_to: end ? `${end}T00:00:00` : null,
    acquisition_reason: form.acquisition_reason || null,
    cessation_reason: end ? (form.cessation_reason || null) : null };
}

const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('it');
export function groupContacts(people, mode) {
  const groups = new Map();
  for (const person of people) {
    const pec = normalize(person.pec);
    const postal = [person.address, person.postal_code, person.city].map(normalize);
    const complete = mode === 'PEC' ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(pec) : postal.every(Boolean);
    const key = complete ? JSON.stringify([mode, ...(mode === 'PEC' ? [pec] : postal)]) : `missing:${person.id}`;
    if (!groups.has(key)) groups.set(key, { key, complete,
      label: complete ? (mode === 'PEC' ? pec : [person.address, person.postal_code, person.city].join(' · ')) : 'Recapito mancante o incompleto', members: [] });
    groups.get(key).members.push(person);
  }
  return [...groups.values()].sort((a, b) => b.members.length - a.members.length || a.label.localeCompare(b.label, 'it'));
}
